const Input = {
	defaultProps: {
		variant: "flushed"
	}
};

export default Input;
